import {
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { CurrencyPipe } from '@angular/common';
import { AdvisorEntity } from '@toro/common/shared/entities/advisor.entity';

@Component({
  selector: 'exclusive-account-advisor',
  templateUrl: './exclusive-account-advisor.component.html',
  styleUrls: ['./exclusive-account-advisor.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CurrencyPipe],
})
export class ExclusiveAccountAdvisorComponent extends DisposableSafelly {
  @Input() public totalNetEquity: number;
  @Input() public advisor: AdvisorEntity;

  public badgeColor = '#221A2C';
  public copyButtonLabel: string;

  constructor() {
    super();
  }

  public copyToClipboard(item) {
    this.copyButtonLabel = 'Código copiado';
    navigator.clipboard.writeText(item);
}
}
